<template>
  <div v-if="contents.length > 0" class="w-full mt-4 mb-8 lg:mb-24 grid grid-cols-2 sm:grid-cols-3 gap-5 sm:gap-10">
    <content-card class="h-auto" v-for="content in contents" :key="`content-home-${content.slug}`" :resource="content" />
  </div>
</template>
<script>

import ContentCard from 'components/contents/Card'

export default {
  name: 'ContentList',

  components: {
    ContentCard
  },

  props: {
    slug: {
      type: String,
      required: true
    }
  },

  data: () => ({
    contents: []
  }),

  created() {
    this.fetchContents()
  },

  methods: {
    fetchContents() {
      this.axios.get(`/api/v1/contents/${this.slug}/relateds`).then(({ data }) => {
        this.contents = data
      }).catch(() => {
        this.contents = []
      })
    }
  }
}
</script>
